import styled from "styled-components";
import { Form as AntdForm, Button, Input } from "antd";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  background-color: #fff; /* Light background */
`;

export const FormContainer = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
  max-width: 450px;
`;

export const Form = styled(AntdForm)`
  margin-top: 1.5rem;
`;

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 1.5rem;
  align-items: center;

  .ant-form-item-explain-error {
    text-align: left;
  }
`;

export const BackToLoginLink = styled.a`
  display: block;
  margin-top: 1rem;
  color: #003b73; /* Blue color from Figma */
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubmitButton = styled(Button)`
  font-weight: 600; /* Matching font weight */
  //   border-radius: 20px;
  background-color: #134076; /* Blue color from Figma */
  border: none;
  max-width: 250px;

  &:hover,
  &:active,
  &:focus {
    background-color: #134076e0;
  }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 1.8rem; /* Adjust font size as per Figma */
  margin-bottom: 1.5rem;
  color: #003b73;
`;

export const FormInput = styled(Input)`
  height: 48px;
  border: 1px solid #e6e6e6;
  font-size: 14px;
  color: #333333;
`;
